import React, { useContext, useEffect, useState } from 'react';
import { ElementConfigType } from '../../store/type';
import { PageEditorStoreContext } from '../../store/PageEditorStore';
import style from './SingleSuperTab.module.scss';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { toJS } from 'mobx';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import { lazy } from 'ice';
import { ConfigHOC } from '../../HOC';

type Props = ElementConfigType;

export const SingleSuperTabComponent: MyComponentType<Props> = (props: Props) => {
  const pageEditorStore = useContext(PageEditorStoreContext);
  const { elements, id, privateSchema, parentNodeIsBody } = props;
  const [tabDate1, setTabDate1] = useState<ElementConfigType[]>([]); // 切换按键
  const [tabContentDate2, setTabContentDate2] = useState<ElementConfigType[]>([]);
  const [tabContentDate3, setTabContentDate3] = useState<ElementConfigType[]>([]);
  const [tabContentDate4, setTabContentDate4] = useState<ElementConfigType[]>([]);
  const [clickIndex, setClickIndex] = useState(0);
  // @ts-ignore
  const { isReverse } = privateSchema;

  useEffect(() => {
    // 设置 点击tap 数据
    setTabDate1(elements.filter((d) => d.index % 4 === 1));
    setTabContentDate2(elements.filter((d) => d.index % 4 === 2));
    setTabContentDate3(elements.filter((d) => d.index % 4 === 3));
    setTabContentDate4(elements.filter((d) => d.index % 4 === 0));
    // elements长度变化 变化 重新选择第一个
    if (elements.length / 4 < clickIndex + 1) {
      setClickIndex(0);
    }
  }, [elements]);

  const handleTabClick = (i) => {
    setClickIndex(i);
  };

  const flexRow = isReverse ? 'md:flex-row-reverse' : 'md:flex-row';
  const flexPadding = !isReverse ? 'md:pr-24' : 'md:pl-24';

  const isButtonShape = privateSchema?.buttonShape === 'circular';
  const ButtonShapeClass = isButtonShape
    ? 'single-tab-title-circular overflow-hidden w-16 md:w-20 2lg:w-24 h-12 md:h-16 2lg:h-20 mt-4 pr-4'
    : 'single-tab-title';
  const flexGrowClass = parentNodeIsBody ? '' : 'flex-grow';
  const itemsEndClass = parentNodeIsBody ? '' : 'items-end';

  return (
    <>
      {/* pc端 */}
      <div
        className={`${style.singleSuper} hidden md:flex flex-col ${flexRow}`}
        style={Object.assign(parentNodeIsBody ? { paddingTop: 16, paddingBottom: 16 } : {})}
        id={id}
      >
        <div className={`w-full md:w-1/2 flex flex-col justify-center ${flexPadding}`}>
          <div className={`flex  ${flexGrowClass} flex-col justify-center`}>
            {(tabContentDate2.length === 0 ? elements.filter((d) => d.index % 4 === 2) : tabContentDate2).map(
              (d, index) => {
                return (
                  <div key={d.nodeId} className={`w-full item flex ${clickIndex !== index ? 'hidden' : ''}`}>
                    <div className="w-full">
                      <props.ComponentBasicRender {...toJS(d)} />
                    </div>
                  </div>
                );
              },
            )}
            {(tabContentDate3.length === 0 ? elements.filter((d) => d.index % 4 === 3) : tabContentDate3).map(
              (d, index) => {
                return (
                  <div key={d.nodeId} className={`w-full item flex ${clickIndex !== index ? 'hidden' : ''}`}>
                    <div className="w-full">
                      <props.ComponentBasicRender {...toJS(d)} />
                    </div>
                  </div>
                );
              },
            )}
          </div>

          <div className={`flex flex-wrap ${itemsEndClass}  z-10 pr-20`}>
            {(tabDate1.length === 0 ? elements.filter((d) => d.index % 4 === 1) : tabDate1).map((d, index) => {
              return (
                <div
                  style={!pageEditorStore.isRenderHtml ? { border: '1px solid #F7C001' } : {}}
                  key={d.nodeId}
                  className={`${ButtonShapeClass} ${clickIndex === index ? 'gold' : ''} flex justify-center`}
                  onClick={() => {
                    handleTabClick(index);
                  }}
                >
                  <button className={`block ${isButtonShape ? '' : 'mr-6 mt-5 pb-1'}`}>
                    <props.ComponentBasicRender {...toJS(d)} height="h-10" />
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        <div className="w-full md:w-1/2 flex flex-col justify-center">
          {(tabContentDate4.length === 0 ? elements.filter((d) => d.index % 4 === 0) : tabContentDate4).map(
            (d, index) => {
              return (
                <div key={d.nodeId} className={`w-full item flex ${clickIndex !== index ? 'hidden' : ''}`}>
                  <div className="w-full">
                    <props.ComponentBasicRender {...toJS(d)} />
                  </div>
                </div>
              );
            },
          )}
        </div>
      </div>
      {/* 移动端 */}
      <div
        className={`${style.singleSuper} md:hidden flex flex-col ${flexRow}`}
        style={Object.assign(parentNodeIsBody ? { paddingTop: 16, paddingBottom: 16 } : {})}
        id={id}
      >
        <div className={`w-full md:w-1/2 flex flex-col justify-center ${flexPadding}`}>
          <div>
            {(tabContentDate2.length === 0 ? elements.filter((d) => d.index % 4 === 2) : tabContentDate2).map(
              (d, index) => {
                return (
                  <div key={d.nodeId} className={`w-full item flex ${clickIndex !== index ? 'hidden' : ''}`}>
                    <div className="w-full mt-5">
                      <props.ComponentBasicRender {...toJS(d)} />
                    </div>
                  </div>
                );
              },
            )}
            {(tabContentDate3.length === 0 ? elements.filter((d) => d.index % 4 === 3) : tabContentDate3).map(
              (d, index) => {
                return (
                  <div key={d.nodeId} className={`w-full item flex ${clickIndex !== index ? 'hidden' : ''}`}>
                    <div className="w-full">
                      <props.ComponentBasicRender {...toJS(d)} />
                    </div>
                  </div>
                );
              },
            )}
          </div>
          <div className="w-full md:w-1/2 flex flex-col justify-center">
            {(tabContentDate4.length === 0 ? elements.filter((d) => d.index % 4 === 0) : tabContentDate4).map(
              (d, index) => {
                return (
                  <div key={d.nodeId} className={`w-full item flex ${clickIndex !== index ? 'hidden' : ''}`}>
                    <div className="w-full">
                      <props.ComponentBasicRender {...toJS(d)} />
                    </div>
                  </div>
                );
              },
            )}
          </div>
        </div>

        <div className="flex flex-nowrap overflow-x-auto z-10 ">
          {(tabDate1.length === 0 ? elements.filter((d) => d.index % 4 === 1) : tabDate1).map((d, index) => {
            const toJSD = toJS(d);
            // 这里处理是为了让移动端文字不换行
            if (toJSD.elements[0]) {
              toJSD.elements[0].styles = { ...(toJSD?.elements[0]?.styles || {}) };
            }

            return (
              <div
                style={!pageEditorStore.isRenderHtml ? { border: '1px solid #F7C001' } : {}}
                key={d.nodeId}
                className={`${ButtonShapeClass} ${clickIndex === index ? 'gold' : ''} flex justify-center `}
                onClick={() => {
                  handleTabClick(index);
                }}
              >
                <button className={`block ${isButtonShape ? '' : 'mr-6 mt-5 pb-1'}`}>
                  <props.ComponentBasicRender {...toJSD} height="h-10" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

const ConfigForm = lazy(() => import('../../components-with-definition/SingleSuperTabComponentDefinition'));

SingleSuperTabComponent.definition = {
  // id: 'single-super-tab-component',
  id: ComponentIdEnum.SINGLE_SUPER_TAB_COMPONENT,
  name: 'Tab切换组件',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/1F9FgNhXRqND8g7b6Dprb',
  position: 4, // 显示顺序
  config: {},
  styles: {
    // paddingTop: 16,
    // paddingBottom: 16,
  },
  privateSchema: {
    subContainersNode: [
      {
        componentId: ComponentIdEnum.TEXT_CONTENT_COMPONENT, // 点击的 文本容器
        privateSchema: {
          text: '48" x 30"',
          opacity: 0.5,
        },
      },
      {
        componentId: ComponentIdEnum.TEXT_TITLE_COMPONENT, // 标题容器
        privateSchema: {
          text: '48" x 30"',
          isShowUnderline: false,
          fontSize: 28, // 16
          fontWeight: 400,
          // eslint-disable-next-line @iceworks/best-practices/recommend-add-line-height-unit
          lineHeight: 28, // 24
        },
      },
      {
        componentId: ComponentIdEnum.TEXT_CONTENT_COMPONENT, // 文本容器
        styles: {
          paddingTop: 16,
        },
        privateSchema: {
          fontWeight: 400,
          text: 'A one-piece design is to make the assembly easier with a more sturdy desktop.',
        },
      },
      {
        componentId: ComponentIdEnum.IMG_COMPONENT,
        config: { src: 'https://cdn.resource.youniverse.cc/d2c-app/R3SpDV8nWeFkMyXDH41Xw.jpg' },
      }, // 图片容器
      {
        componentId: ComponentIdEnum.TEXT_CONTENT_COMPONENT,
        privateSchema: {
          text: '55" x 28"',
          opacity: 0.5,
        },
      },
      {
        componentId: ComponentIdEnum.TEXT_TITLE_COMPONENT,
        privateSchema: {
          text: '55" x 28"',
          isShowUnderline: false,
          fontSize: 28, // 16
          fontWeight: 400,
          // eslint-disable-next-line @iceworks/best-practices/recommend-add-line-height-unit
          lineHeight: 28, // 24
        },
      },
      {
        componentId: ComponentIdEnum.TEXT_CONTENT_COMPONENT,
        styles: {
          paddingTop: 16,
        },
        privateSchema: {
          fontWeight: 400,
          text: 'A one-piece design is to make the assembly easier with a more sturdy desktop.',
        },
      },
      {
        componentId: ComponentIdEnum.IMG_COMPONENT,
        config: { src: 'https://cdn.resource.youniverse.cc/d2c-app/QZKaZHXzTToel_3BnRJLN.jpg' },
      },
    ], // 会有几个子容器
    isReverse: true, // 是否翻转
  }, // 组件自己的属性 不能通用的部分
  category: 'interactive',
  configForm: ConfigHOC(ConfigForm),
};
